import React from 'react';

const StripeErrorPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="bg-white p-8 rounded shadow text-center">
      <h2 className="text-2xl font-bold mb-4">Payment Error</h2>
      <p className="mb-4">Unable to load payment form. Please try again later.</p>
      <a href="/" className="text-blue-600 underline">Go Home</a>
    </div>
  </div>
);

export default StripeErrorPage;
